import { useProTableSortPersistence as useSharedSortPersistence } from "../../../../../../shared/frontend/settings/proTableSortPersistence";
import { useUiPreferences } from "../prefs/useUiPreferences";
export * from "../../../../../../shared/frontend/settings/proTableSortPersistence";
export function useProTableSortPersistence(accountIdRaw: string | null | undefined, tableKey: string) {
  return useSharedSortPersistence(accountIdRaw, tableKey, useUiPreferences());
}
